
import { Component, Input } from '@angular/core';

@Component({
  selector: 'prcins-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css']
})
export class TabComponent {

  @Input() title!: string;
  @Input() active = false;

}
